import gql from "graphql-tag";

export default gql`
  query BuildingCollectionsCalendarAvailabilitiesQuery(
    $id: ID!
    $checkInDate: String
    $startCursor: String
    $endCursor: String
    $guestCount: Int
  ) {
    buildingCollectionsCalendarAvailabilities(
      id: $id
      checkInDate: $checkInDate
      startCursor: $startCursor
      endCursor: $endCursor
      guestCount: $guestCount
    ) {
      date
      minimumStayLength
      checkinAvailable
    }
  }
`;
